"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuncaoAjuda = exports.FuncaoJanelas = exports.FuncaoInternet = exports.FuncaoUtilitarios = exports.FuncaoEstatastica = exports.FuncaoAdministracao = exports.FuncaoTesouraria = exports.FuncaoSecretaria = exports.FuncaoCadastro = exports.FuncaoArquivo = exports.FuncaoClientes = exports.FuncaoContasPagar = exports.FuncaoCheques = exports.FuncaoConfiguracoes = exports.FuncaoCaixa = exports.FuncaoExAlunos = exports.FuncaoTurmas = exports.FuncaoNotasAlunos = exports.FuncaoMensalidades = exports.FuncaoContasBancarias = exports.FuncaoHistoricoPadrao = exports.FuncaoPlanoContas = exports.FuncaoFuncProfessores = exports.FuncaoFornecedores = exports.FuncaoAlunos = exports.FuncaoGradeProfessores = exports.FuncaoGradeMaterias = exports.FuncaoMaterias = exports.FuncaoSeries = exports.FuncaoCursos = exports.FuncaoOpcoesUsuario = exports.GrupoPermissoes = void 0;
var GrupoPermissoes;
(function (GrupoPermissoes) {
    GrupoPermissoes[GrupoPermissoes["OpcoesUsuario"] = 1] = "OpcoesUsuario";
    GrupoPermissoes[GrupoPermissoes["Cursos"] = 2] = "Cursos";
    GrupoPermissoes[GrupoPermissoes["Series"] = 3] = "Series";
    GrupoPermissoes[GrupoPermissoes["Materias"] = 4] = "Materias";
    GrupoPermissoes[GrupoPermissoes["GradeMaterias"] = 5] = "GradeMaterias";
    GrupoPermissoes[GrupoPermissoes["GradeProfessores"] = 6] = "GradeProfessores";
    GrupoPermissoes[GrupoPermissoes["Alunos"] = 7] = "Alunos";
    GrupoPermissoes[GrupoPermissoes["Fornecedores"] = 8] = "Fornecedores";
    GrupoPermissoes[GrupoPermissoes["FuncProfessores"] = 9] = "FuncProfessores";
    GrupoPermissoes[GrupoPermissoes["PlanoContas"] = 10] = "PlanoContas";
    GrupoPermissoes[GrupoPermissoes["HistoricoPadrao"] = 11] = "HistoricoPadrao";
    GrupoPermissoes[GrupoPermissoes["ContasBancarias"] = 12] = "ContasBancarias";
    GrupoPermissoes[GrupoPermissoes["Mensalidades"] = 13] = "Mensalidades";
    GrupoPermissoes[GrupoPermissoes["NotasAlunos"] = 14] = "NotasAlunos";
    GrupoPermissoes[GrupoPermissoes["Turmas"] = 15] = "Turmas";
    GrupoPermissoes[GrupoPermissoes["ExAlunos"] = 16] = "ExAlunos";
    GrupoPermissoes[GrupoPermissoes["Caixa"] = 17] = "Caixa";
    GrupoPermissoes[GrupoPermissoes["Configuracoes"] = 18] = "Configuracoes";
    GrupoPermissoes[GrupoPermissoes["Cheques"] = 19] = "Cheques";
    GrupoPermissoes[GrupoPermissoes["ContasPagar"] = 20] = "ContasPagar";
    GrupoPermissoes[GrupoPermissoes["Clientes"] = 21] = "Clientes";
    GrupoPermissoes[GrupoPermissoes["OpcoesMenu"] = 22] = "OpcoesMenu";
    GrupoPermissoes[GrupoPermissoes["Arquivo"] = 23] = "Arquivo";
    GrupoPermissoes[GrupoPermissoes["Cadastro"] = 24] = "Cadastro";
    GrupoPermissoes[GrupoPermissoes["Secretaria"] = 25] = "Secretaria";
    GrupoPermissoes[GrupoPermissoes["Tesouraria"] = 26] = "Tesouraria";
    GrupoPermissoes[GrupoPermissoes["Administracao"] = 27] = "Administracao";
    GrupoPermissoes[GrupoPermissoes["Estatastica"] = 28] = "Estatastica";
    GrupoPermissoes[GrupoPermissoes["Utilitarios"] = 29] = "Utilitarios";
    GrupoPermissoes[GrupoPermissoes["Internet"] = 30] = "Internet";
    GrupoPermissoes[GrupoPermissoes["Janelas"] = 31] = "Janelas";
    GrupoPermissoes[GrupoPermissoes["Ajuda"] = 32] = "Ajuda";
})(GrupoPermissoes = exports.GrupoPermissoes || (exports.GrupoPermissoes = {}));
var FuncaoOpcoesUsuario;
(function (FuncaoOpcoesUsuario) {
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["Habilitado"] = 1] = "Habilitado";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["UsuarioMASTER"] = 2] = "UsuarioMASTER";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["SupervisorSistema"] = 3] = "SupervisorSistema";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["ProfessorOnlineConsultar"] = 4] = "ProfessorOnlineConsultar";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["ProfessorOnlineAlterar"] = 5] = "ProfessorOnlineAlterar";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["ProfessorOnlineAvisosAlterar"] = 6] = "ProfessorOnlineAvisosAlterar";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["ProfessorOnlineOcorrenciasAlterar"] = 7] = "ProfessorOnlineOcorrenciasAlterar";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["ProfessorOnlineConfiguracoes"] = 8] = "ProfessorOnlineConfiguracoes";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["DadosPessoais"] = 9] = "DadosPessoais";
    FuncaoOpcoesUsuario[FuncaoOpcoesUsuario["DadosSensiveis"] = 0] = "DadosSensiveis";
})(FuncaoOpcoesUsuario = exports.FuncaoOpcoesUsuario || (exports.FuncaoOpcoesUsuario = {}));
var FuncaoCursos;
(function (FuncaoCursos) {
    FuncaoCursos[FuncaoCursos["Incluir"] = 1] = "Incluir";
    FuncaoCursos[FuncaoCursos["Alterar"] = 2] = "Alterar";
    FuncaoCursos[FuncaoCursos["Excluir"] = 3] = "Excluir";
    FuncaoCursos[FuncaoCursos["Relatorios"] = 4] = "Relatorios";
    FuncaoCursos[FuncaoCursos["ReajustarMensalidades"] = 5] = "ReajustarMensalidades";
})(FuncaoCursos = exports.FuncaoCursos || (exports.FuncaoCursos = {}));
var FuncaoSeries;
(function (FuncaoSeries) {
    FuncaoSeries[FuncaoSeries["Incluir"] = 1] = "Incluir";
    FuncaoSeries[FuncaoSeries["Alterar"] = 2] = "Alterar";
    FuncaoSeries[FuncaoSeries["Excluir"] = 3] = "Excluir";
    FuncaoSeries[FuncaoSeries["Movimento"] = 4] = "Movimento";
    FuncaoSeries[FuncaoSeries["Relatorios"] = 5] = "Relatorios";
    FuncaoSeries[FuncaoSeries["Notas"] = 6] = "Notas";
    FuncaoSeries[FuncaoSeries["AulasDadas"] = 7] = "AulasDadas";
    FuncaoSeries[FuncaoSeries["IncluirMateriasGrade"] = 8] = "IncluirMateriasGrade";
    FuncaoSeries[FuncaoSeries["AlteraMateriaGrade"] = 9] = "AlteraMateriaGrade";
    FuncaoSeries[FuncaoSeries["ExcluirMateriaGrade"] = 10] = "ExcluirMateriaGrade";
    FuncaoSeries[FuncaoSeries["IndicarProfessor"] = 11] = "IndicarProfessor";
    FuncaoSeries[FuncaoSeries["AlterarNChamada"] = 12] = "AlterarNChamada";
    FuncaoSeries[FuncaoSeries["AlterarDadosCadastrais"] = 13] = "AlterarDadosCadastrais";
    FuncaoSeries[FuncaoSeries["CancelarMatricula"] = 14] = "CancelarMatricula";
    FuncaoSeries[FuncaoSeries["ImprimirListaAlunos"] = 15] = "ImprimirListaAlunos";
    FuncaoSeries[FuncaoSeries["ImprimirDiarioClasse"] = 16] = "ImprimirDiarioClasse";
    FuncaoSeries[FuncaoSeries["DigitacaoNotas"] = 17] = "DigitacaoNotas";
    FuncaoSeries[FuncaoSeries["ExcluirNomeLista"] = 18] = "ExcluirNomeLista";
    FuncaoSeries[FuncaoSeries["GerarChamada"] = 19] = "GerarChamada";
    FuncaoSeries[FuncaoSeries["FixarChamada"] = 20] = "FixarChamada";
    FuncaoSeries[FuncaoSeries["AlterarDataSaida"] = 21] = "AlterarDataSaida";
    FuncaoSeries[FuncaoSeries["RemanejarAluno"] = 22] = "RemanejarAluno";
})(FuncaoSeries = exports.FuncaoSeries || (exports.FuncaoSeries = {}));
var FuncaoMaterias;
(function (FuncaoMaterias) {
    FuncaoMaterias[FuncaoMaterias["Incluir"] = 1] = "Incluir";
    FuncaoMaterias[FuncaoMaterias["Alterar"] = 2] = "Alterar";
    FuncaoMaterias[FuncaoMaterias["Excluir"] = 3] = "Excluir";
    FuncaoMaterias[FuncaoMaterias["Relatorios"] = 4] = "Relatorios";
    FuncaoMaterias[FuncaoMaterias["SeqHistoricoEscolar"] = 5] = "SeqHistoricoEscolar";
})(FuncaoMaterias = exports.FuncaoMaterias || (exports.FuncaoMaterias = {}));
var FuncaoGradeMaterias;
(function (FuncaoGradeMaterias) {
    FuncaoGradeMaterias[FuncaoGradeMaterias["Incluir"] = 1] = "Incluir";
    FuncaoGradeMaterias[FuncaoGradeMaterias["Alterar"] = 2] = "Alterar";
    FuncaoGradeMaterias[FuncaoGradeMaterias["Excluir"] = 3] = "Excluir";
    FuncaoGradeMaterias[FuncaoGradeMaterias["Relatorios"] = 4] = "Relatorios";
})(FuncaoGradeMaterias = exports.FuncaoGradeMaterias || (exports.FuncaoGradeMaterias = {}));
var FuncaoGradeProfessores;
(function (FuncaoGradeProfessores) {
    FuncaoGradeProfessores[FuncaoGradeProfessores["Incluir"] = 1] = "Incluir";
    FuncaoGradeProfessores[FuncaoGradeProfessores["Alterar"] = 2] = "Alterar";
    FuncaoGradeProfessores[FuncaoGradeProfessores["Excluir"] = 3] = "Excluir";
    FuncaoGradeProfessores[FuncaoGradeProfessores["Relatorios"] = 4] = "Relatorios";
})(FuncaoGradeProfessores = exports.FuncaoGradeProfessores || (exports.FuncaoGradeProfessores = {}));
var FuncaoAlunos;
(function (FuncaoAlunos) {
    FuncaoAlunos[FuncaoAlunos["Incluir"] = 1] = "Incluir";
    FuncaoAlunos[FuncaoAlunos["Alterar"] = 2] = "Alterar";
    FuncaoAlunos[FuncaoAlunos["Excluir"] = 3] = "Excluir";
    FuncaoAlunos[FuncaoAlunos["Relatorios"] = 4] = "Relatorios";
    FuncaoAlunos[FuncaoAlunos["Mensalidades"] = 5] = "Mensalidades";
    FuncaoAlunos[FuncaoAlunos["Matricula"] = 6] = "Matricula";
    FuncaoAlunos[FuncaoAlunos["MudarSituacaoAluno"] = 7] = "MudarSituacaoAluno";
    FuncaoAlunos[FuncaoAlunos["Boletim"] = 8] = "Boletim";
    FuncaoAlunos[FuncaoAlunos["ConsultarOcorrencias"] = 9] = "ConsultarOcorrencias";
    FuncaoAlunos[FuncaoAlunos["Desistencia"] = 10] = "Desistencia";
    FuncaoAlunos[FuncaoAlunos["Transferencia"] = 11] = "Transferencia";
    FuncaoAlunos[FuncaoAlunos["CancelamentoMatricula"] = 12] = "CancelamentoMatricula";
    FuncaoAlunos[FuncaoAlunos["RequerimentoMatricula"] = 13] = "RequerimentoMatricula";
    FuncaoAlunos[FuncaoAlunos["DeclaracaoMatricula"] = 14] = "DeclaracaoMatricula";
    FuncaoAlunos[FuncaoAlunos["RequerimentoTransferencia"] = 15] = "RequerimentoTransferencia";
    FuncaoAlunos[FuncaoAlunos["FichaIndividual"] = 16] = "FichaIndividual";
    FuncaoAlunos[FuncaoAlunos["HistoricoEscolar"] = 17] = "HistoricoEscolar";
    FuncaoAlunos[FuncaoAlunos["DeclaracaoFrequencia"] = 18] = "DeclaracaoFrequencia";
    FuncaoAlunos[FuncaoAlunos["DeclaracaoTransferencia"] = 19] = "DeclaracaoTransferencia";
    FuncaoAlunos[FuncaoAlunos["Frequencia"] = 20] = "Frequencia";
    FuncaoAlunos[FuncaoAlunos["Falecimento"] = 21] = "Falecimento";
    FuncaoAlunos[FuncaoAlunos["Turma"] = 22] = "Turma";
    FuncaoAlunos[FuncaoAlunos["CadastrarOcorrencias"] = 23] = "CadastrarOcorrencias";
    FuncaoAlunos[FuncaoAlunos["InformarDescontoMatricula"] = 24] = "InformarDescontoMatricula";
    FuncaoAlunos[FuncaoAlunos["InformarData1Vencimento"] = 25] = "InformarData1Vencimento";
    FuncaoAlunos[FuncaoAlunos["Cheques"] = 26] = "Cheques";
    FuncaoAlunos[FuncaoAlunos["AdaptacaoDependencia"] = 27] = "AdaptacaoDependencia";
    FuncaoAlunos[FuncaoAlunos["Emprestimos"] = 28] = "Emprestimos";
    FuncaoAlunos[FuncaoAlunos["Gratuidades"] = 29] = "Gratuidades";
    FuncaoAlunos[FuncaoAlunos["SituacaoFinanceira"] = 30] = "SituacaoFinanceira";
    FuncaoAlunos[FuncaoAlunos["FichaFamiliar"] = 31] = "FichaFamiliar";
    FuncaoAlunos[FuncaoAlunos["AlterarDataMatricula"] = 32] = "AlterarDataMatricula";
    FuncaoAlunos[FuncaoAlunos["VisualizarOcorrenciasOcultas"] = 33] = "VisualizarOcorrenciasOcultas";
    FuncaoAlunos[FuncaoAlunos["AtestadosMedicos"] = 34] = "AtestadosMedicos";
})(FuncaoAlunos = exports.FuncaoAlunos || (exports.FuncaoAlunos = {}));
var FuncaoFornecedores;
(function (FuncaoFornecedores) {
    FuncaoFornecedores[FuncaoFornecedores["Incluir"] = 1] = "Incluir";
    FuncaoFornecedores[FuncaoFornecedores["Alterar"] = 2] = "Alterar";
    FuncaoFornecedores[FuncaoFornecedores["Excluir"] = 3] = "Excluir";
    FuncaoFornecedores[FuncaoFornecedores["Relatorios"] = 4] = "Relatorios";
})(FuncaoFornecedores = exports.FuncaoFornecedores || (exports.FuncaoFornecedores = {}));
var FuncaoFuncProfessores;
(function (FuncaoFuncProfessores) {
    FuncaoFuncProfessores[FuncaoFuncProfessores["Incluir"] = 1] = "Incluir";
    FuncaoFuncProfessores[FuncaoFuncProfessores["Alterar"] = 2] = "Alterar";
    FuncaoFuncProfessores[FuncaoFuncProfessores["Excluir"] = 3] = "Excluir";
    FuncaoFuncProfessores[FuncaoFuncProfessores["Relatorios"] = 4] = "Relatorios";
})(FuncaoFuncProfessores = exports.FuncaoFuncProfessores || (exports.FuncaoFuncProfessores = {}));
var FuncaoPlanoContas;
(function (FuncaoPlanoContas) {
    FuncaoPlanoContas[FuncaoPlanoContas["Incluir"] = 1] = "Incluir";
    FuncaoPlanoContas[FuncaoPlanoContas["Alterar"] = 2] = "Alterar";
    FuncaoPlanoContas[FuncaoPlanoContas["Excluir"] = 3] = "Excluir";
    FuncaoPlanoContas[FuncaoPlanoContas["Relatorios"] = 4] = "Relatorios";
    FuncaoPlanoContas[FuncaoPlanoContas["FichaRazao"] = 5] = "FichaRazao";
})(FuncaoPlanoContas = exports.FuncaoPlanoContas || (exports.FuncaoPlanoContas = {}));
var FuncaoHistoricoPadrao;
(function (FuncaoHistoricoPadrao) {
    FuncaoHistoricoPadrao[FuncaoHistoricoPadrao["Incluir"] = 1] = "Incluir";
    FuncaoHistoricoPadrao[FuncaoHistoricoPadrao["Alterar"] = 2] = "Alterar";
    FuncaoHistoricoPadrao[FuncaoHistoricoPadrao["Excluir"] = 3] = "Excluir";
    FuncaoHistoricoPadrao[FuncaoHistoricoPadrao["Relatorios"] = 4] = "Relatorios";
})(FuncaoHistoricoPadrao = exports.FuncaoHistoricoPadrao || (exports.FuncaoHistoricoPadrao = {}));
var FuncaoContasBancarias;
(function (FuncaoContasBancarias) {
    FuncaoContasBancarias[FuncaoContasBancarias["Incluir"] = 1] = "Incluir";
    FuncaoContasBancarias[FuncaoContasBancarias["Alterar"] = 2] = "Alterar";
    FuncaoContasBancarias[FuncaoContasBancarias["Excluir"] = 3] = "Excluir";
    FuncaoContasBancarias[FuncaoContasBancarias["Relatorios"] = 4] = "Relatorios";
    FuncaoContasBancarias[FuncaoContasBancarias["Movimento"] = 5] = "Movimento";
})(FuncaoContasBancarias = exports.FuncaoContasBancarias || (exports.FuncaoContasBancarias = {}));
var FuncaoMensalidades;
(function (FuncaoMensalidades) {
    FuncaoMensalidades[FuncaoMensalidades["Incluir"] = 1] = "Incluir";
    FuncaoMensalidades[FuncaoMensalidades["Alterar"] = 2] = "Alterar";
    FuncaoMensalidades[FuncaoMensalidades["Receber"] = 3] = "Receber";
    FuncaoMensalidades[FuncaoMensalidades["Estornar"] = 4] = "Estornar";
    FuncaoMensalidades[FuncaoMensalidades["Recibos"] = 5] = "Recibos";
    FuncaoMensalidades[FuncaoMensalidades["RelMensalidadesAtraso"] = 6] = "RelMensalidadesAtraso";
    FuncaoMensalidades[FuncaoMensalidades["RelPendenciasDesistentes"] = 7] = "RelPendenciasDesistentes";
    FuncaoMensalidades[FuncaoMensalidades["RelPendenciasAprovados"] = 8] = "RelPendenciasAprovados";
    FuncaoMensalidades[FuncaoMensalidades["RelPrevisaoRecebimento"] = 9] = "RelPrevisaoRecebimento";
    FuncaoMensalidades[FuncaoMensalidades["RelValoresRecebidos"] = 10] = "RelValoresRecebidos";
    FuncaoMensalidades[FuncaoMensalidades["RelValoresRecebidosVencimento"] = 11] = "RelValoresRecebidosVencimento";
    FuncaoMensalidades[FuncaoMensalidades["EmissaoCartasCobranca"] = 12] = "EmissaoCartasCobranca";
    FuncaoMensalidades[FuncaoMensalidades["SituacaoFinanceiraAluno"] = 13] = "SituacaoFinanceiraAluno";
    FuncaoMensalidades[FuncaoMensalidades["ResumoPosicaoFinanceira"] = 14] = "ResumoPosicaoFinanceira";
    FuncaoMensalidades[FuncaoMensalidades["MapaMensalidadesRecebidas"] = 15] = "MapaMensalidadesRecebidas";
    FuncaoMensalidades[FuncaoMensalidades["Excluir"] = 16] = "Excluir";
    FuncaoMensalidades[FuncaoMensalidades["MapaPrevisaoRecebimentos"] = 17] = "MapaPrevisaoRecebimentos";
    FuncaoMensalidades[FuncaoMensalidades["AutenticarRecebimentos"] = 18] = "AutenticarRecebimentos";
    FuncaoMensalidades[FuncaoMensalidades["LiberarJurosBaixa"] = 19] = "LiberarJurosBaixa";
    FuncaoMensalidades[FuncaoMensalidades["InformarValorRecebidoBaixa"] = 20] = "InformarValorRecebidoBaixa";
    FuncaoMensalidades[FuncaoMensalidades["ResumoCobrancaMensal"] = 21] = "ResumoCobrancaMensal";
    FuncaoMensalidades[FuncaoMensalidades["ResumoCobrancaDiaria"] = 22] = "ResumoCobrancaDiaria";
    FuncaoMensalidades[FuncaoMensalidades["ReciboImpostoRenda"] = 23] = "ReciboImpostoRenda";
    FuncaoMensalidades[FuncaoMensalidades["ResumoRecebimentoMensal"] = 24] = "ResumoRecebimentoMensal";
    FuncaoMensalidades[FuncaoMensalidades["AlterarVencimentoMensalidades"] = 25] = "AlterarVencimentoMensalidades";
    FuncaoMensalidades[FuncaoMensalidades["AlterarTipoDescRecebido"] = 26] = "AlterarTipoDescRecebido";
    FuncaoMensalidades[FuncaoMensalidades["ReceberCaixaTesouraria"] = 27] = "ReceberCaixaTesouraria";
    FuncaoMensalidades[FuncaoMensalidades["ReceberContasBancarias"] = 28] = "ReceberContasBancarias";
    FuncaoMensalidades[FuncaoMensalidades["AlterarDataRecebimentoBaixa"] = 29] = "AlterarDataRecebimentoBaixa";
    FuncaoMensalidades[FuncaoMensalidades["ConcederDescontoBaixa"] = 30] = "ConcederDescontoBaixa";
    FuncaoMensalidades[FuncaoMensalidades["AjustarMensalidadesFilantropia"] = 31] = "AjustarMensalidadesFilantropia";
    FuncaoMensalidades[FuncaoMensalidades["AlterarValorMensalidades"] = 32] = "AlterarValorMensalidades";
    FuncaoMensalidades[FuncaoMensalidades["AlterarPerdeDescAposVenc"] = 33] = "AlterarPerdeDescAposVenc";
    FuncaoMensalidades[FuncaoMensalidades["Devolver"] = 34] = "Devolver";
    FuncaoMensalidades[FuncaoMensalidades["AlterarDataCreditoBaixaManual"] = 35] = "AlterarDataCreditoBaixaManual";
})(FuncaoMensalidades = exports.FuncaoMensalidades || (exports.FuncaoMensalidades = {}));
var FuncaoNotasAlunos;
(function (FuncaoNotasAlunos) {
    FuncaoNotasAlunos[FuncaoNotasAlunos["DigitarNota"] = 1] = "DigitarNota";
    FuncaoNotasAlunos[FuncaoNotasAlunos["IncluirMateriasExtras"] = 2] = "IncluirMateriasExtras";
    FuncaoNotasAlunos[FuncaoNotasAlunos["ExcluirMateriasExtras"] = 3] = "ExcluirMateriasExtras";
    FuncaoNotasAlunos[FuncaoNotasAlunos["Relatorios"] = 4] = "Relatorios";
})(FuncaoNotasAlunos = exports.FuncaoNotasAlunos || (exports.FuncaoNotasAlunos = {}));
var FuncaoTurmas;
(function (FuncaoTurmas) {
    FuncaoTurmas[FuncaoTurmas["Incluir"] = 1] = "Incluir";
    FuncaoTurmas[FuncaoTurmas["Alterar"] = 2] = "Alterar";
    FuncaoTurmas[FuncaoTurmas["Excluir"] = 3] = "Excluir";
    FuncaoTurmas[FuncaoTurmas["Relatorios"] = 4] = "Relatorios";
})(FuncaoTurmas = exports.FuncaoTurmas || (exports.FuncaoTurmas = {}));
var FuncaoExAlunos;
(function (FuncaoExAlunos) {
    FuncaoExAlunos[FuncaoExAlunos["Incluir"] = 1] = "Incluir";
    FuncaoExAlunos[FuncaoExAlunos["Alterar"] = 2] = "Alterar";
    FuncaoExAlunos[FuncaoExAlunos["Excluir"] = 3] = "Excluir";
    FuncaoExAlunos[FuncaoExAlunos["Relatorios"] = 4] = "Relatorios";
})(FuncaoExAlunos = exports.FuncaoExAlunos || (exports.FuncaoExAlunos = {}));
var FuncaoCaixa;
(function (FuncaoCaixa) {
    FuncaoCaixa[FuncaoCaixa["Lancamento"] = 1] = "Lancamento";
    FuncaoCaixa[FuncaoCaixa["Alterar"] = 2] = "Alterar";
    FuncaoCaixa[FuncaoCaixa["Estornar"] = 3] = "Estornar";
    FuncaoCaixa[FuncaoCaixa["Relatorios"] = 4] = "Relatorios";
})(FuncaoCaixa = exports.FuncaoCaixa || (exports.FuncaoCaixa = {}));
var FuncaoConfiguracoes;
(function (FuncaoConfiguracoes) {
    FuncaoConfiguracoes[FuncaoConfiguracoes["IdentificacaoEscola"] = 1] = "IdentificacaoEscola";
    FuncaoConfiguracoes[FuncaoConfiguracoes["SistemaAvaliacao"] = 2] = "SistemaAvaliacao";
    FuncaoConfiguracoes[FuncaoConfiguracoes["DadosParaCobranca"] = 3] = "DadosParaCobranca";
    FuncaoConfiguracoes[FuncaoConfiguracoes["ConfiguracoesGerais"] = 4] = "ConfiguracoesGerais";
    FuncaoConfiguracoes[FuncaoConfiguracoes["Logotipos"] = 5] = "Logotipos";
    FuncaoConfiguracoes[FuncaoConfiguracoes["DadosDiretoraSecretaria"] = 6] = "DadosDiretoraSecretaria";
    FuncaoConfiguracoes[FuncaoConfiguracoes["ConfiguracoesBancarias"] = 7] = "ConfiguracoesBancarias";
    FuncaoConfiguracoes[FuncaoConfiguracoes["LeisDocumentos"] = 8] = "LeisDocumentos";
    FuncaoConfiguracoes[FuncaoConfiguracoes["MudarBimestreAtivoRecupFinalizada"] = 9] = "MudarBimestreAtivoRecupFinalizada";
    FuncaoConfiguracoes[FuncaoConfiguracoes["ConfiguracoesBoletim"] = 10] = "ConfiguracoesBoletim";
})(FuncaoConfiguracoes = exports.FuncaoConfiguracoes || (exports.FuncaoConfiguracoes = {}));
var FuncaoCheques;
(function (FuncaoCheques) {
    FuncaoCheques[FuncaoCheques["Incluir"] = 1] = "Incluir";
    FuncaoCheques[FuncaoCheques["Alterar"] = 2] = "Alterar";
    FuncaoCheques[FuncaoCheques["Excluir"] = 3] = "Excluir";
    FuncaoCheques[FuncaoCheques["Devolucao"] = 4] = "Devolucao";
    FuncaoCheques[FuncaoCheques["Visualizar"] = 5] = "Visualizar";
    FuncaoCheques[FuncaoCheques["Baixar"] = 6] = "Baixar";
    FuncaoCheques[FuncaoCheques["Imprimir"] = 7] = "Imprimir";
})(FuncaoCheques = exports.FuncaoCheques || (exports.FuncaoCheques = {}));
var FuncaoContasPagar;
(function (FuncaoContasPagar) {
    FuncaoContasPagar[FuncaoContasPagar["Incluir"] = 1] = "Incluir";
    FuncaoContasPagar[FuncaoContasPagar["Alterar"] = 2] = "Alterar";
    FuncaoContasPagar[FuncaoContasPagar["Excluir"] = 3] = "Excluir";
    FuncaoContasPagar[FuncaoContasPagar["Baixar"] = 4] = "Baixar";
    FuncaoContasPagar[FuncaoContasPagar["Estornar"] = 5] = "Estornar";
    FuncaoContasPagar[FuncaoContasPagar["Relatorios"] = 6] = "Relatorios";
})(FuncaoContasPagar = exports.FuncaoContasPagar || (exports.FuncaoContasPagar = {}));
var FuncaoClientes;
(function (FuncaoClientes) {
    FuncaoClientes[FuncaoClientes["Incluir"] = 1] = "Incluir";
    FuncaoClientes[FuncaoClientes["Alterar"] = 2] = "Alterar";
    FuncaoClientes[FuncaoClientes["Excluir"] = 3] = "Excluir";
    FuncaoClientes[FuncaoClientes["InclurExcluirFilhos"] = 4] = "InclurExcluirFilhos";
    FuncaoClientes[FuncaoClientes["Relatorios"] = 5] = "Relatorios";
})(FuncaoClientes = exports.FuncaoClientes || (exports.FuncaoClientes = {}));
var FuncaoArquivo;
(function (FuncaoArquivo) {
    FuncaoArquivo[FuncaoArquivo["CriarBaseDados"] = 1] = "CriarBaseDados";
    FuncaoArquivo[FuncaoArquivo["ReconstruirBaseDados"] = 2] = "ReconstruirBaseDados";
    FuncaoArquivo[FuncaoArquivo["ReindexarBasesDados"] = 3] = "ReindexarBasesDados";
    FuncaoArquivo[FuncaoArquivo["RefazerBalancoAbertura"] = 4] = "RefazerBalancoAbertura";
    FuncaoArquivo[FuncaoArquivo["RecalcularSaldosPlanoContas"] = 5] = "RecalcularSaldosPlanoContas";
    FuncaoArquivo[FuncaoArquivo["AtualizarPlanoHistoricoOutrosAnos"] = 6] = "AtualizarPlanoHistoricoOutrosAnos";
    FuncaoArquivo[FuncaoArquivo["SelecionarArquivos"] = 7] = "SelecionarArquivos";
    FuncaoArquivo[FuncaoArquivo["CopiaSeguranca"] = 8] = "CopiaSeguranca";
    FuncaoArquivo[FuncaoArquivo["RestaurarCopiaSeguranca"] = 9] = "RestaurarCopiaSeguranca";
    FuncaoArquivo[FuncaoArquivo["RecalcularNotas"] = 10] = "RecalcularNotas";
    FuncaoArquivo[FuncaoArquivo["ReprocessarContabilidade"] = 11] = "ReprocessarContabilidade";
    FuncaoArquivo[FuncaoArquivo["ImportacaoExportacaoDados"] = 12] = "ImportacaoExportacaoDados";
    FuncaoArquivo[FuncaoArquivo["DiretorioTrabalho"] = 13] = "DiretorioTrabalho";
    FuncaoArquivo[FuncaoArquivo["AnoAtivo"] = 14] = "AnoAtivo";
    FuncaoArquivo[FuncaoArquivo["ConfigurarImpressora"] = 15] = "ConfigurarImpressora";
    FuncaoArquivo[FuncaoArquivo["ConfiguracoesEscola"] = 16] = "ConfiguracoesEscola";
    FuncaoArquivo[FuncaoArquivo["CadastroUsuarios"] = 17] = "CadastroUsuarios";
    FuncaoArquivo[FuncaoArquivo["NovoLogin"] = 18] = "NovoLogin";
    FuncaoArquivo[FuncaoArquivo["SairAplicacao"] = 19] = "SairAplicacao";
})(FuncaoArquivo = exports.FuncaoArquivo || (exports.FuncaoArquivo = {}));
var FuncaoCadastro;
(function (FuncaoCadastro) {
    FuncaoCadastro[FuncaoCadastro["Cursos"] = 1] = "Cursos";
    FuncaoCadastro[FuncaoCadastro["Series"] = 2] = "Series";
    FuncaoCadastro[FuncaoCadastro["Materias"] = 3] = "Materias";
    FuncaoCadastro[FuncaoCadastro["TiposOcorrencia"] = 4] = "TiposOcorrencia";
    FuncaoCadastro[FuncaoCadastro["CategoriasOcorrencia"] = 5] = "CategoriasOcorrencia";
    FuncaoCadastro[FuncaoCadastro["ProfessoresFuncionarios"] = 6] = "ProfessoresFuncionarios";
    FuncaoCadastro[FuncaoCadastro["Alunos"] = 7] = "Alunos";
    FuncaoCadastro[FuncaoCadastro["Clientes"] = 8] = "Clientes";
    FuncaoCadastro[FuncaoCadastro["Fornecedores"] = 9] = "Fornecedores";
    FuncaoCadastro[FuncaoCadastro["PlanoContas"] = 10] = "PlanoContas";
    FuncaoCadastro[FuncaoCadastro["HistoricoPadrao"] = 11] = "HistoricoPadrao";
    FuncaoCadastro[FuncaoCadastro["ContasBancarias"] = 12] = "ContasBancarias";
    FuncaoCadastro[FuncaoCadastro["ExAlunos"] = 13] = "ExAlunos";
    FuncaoCadastro[FuncaoCadastro["GrupoProdutos"] = 14] = "GrupoProdutos";
    FuncaoCadastro[FuncaoCadastro["Produtos"] = 15] = "Produtos";
    FuncaoCadastro[FuncaoCadastro["PlanosPagamento"] = 16] = "PlanosPagamento";
    FuncaoCadastro[FuncaoCadastro["Horarios"] = 17] = "Horarios";
    FuncaoCadastro[FuncaoCadastro["GradeAulas"] = 18] = "GradeAulas";
    FuncaoCadastro[FuncaoCadastro["ConteudoMinistrado"] = 19] = "ConteudoMinistrado";
    FuncaoCadastro[FuncaoCadastro["TiposDesconto"] = 20] = "TiposDesconto";
    FuncaoCadastro[FuncaoCadastro["GradeCurricular"] = 21] = "GradeCurricular";
    FuncaoCadastro[FuncaoCadastro["InclusaoAlunosNovos"] = 22] = "InclusaoAlunosNovos";
    FuncaoCadastro[FuncaoCadastro["CategoriasAlunos"] = 23] = "CategoriasAlunos";
    FuncaoCadastro[FuncaoCadastro["AgendaEventos"] = 24] = "AgendaEventos";
    FuncaoCadastro[FuncaoCadastro["EmprestimoLivros"] = 25] = "EmprestimoLivros";
    FuncaoCadastro[FuncaoCadastro["Bairros"] = 26] = "Bairros";
    FuncaoCadastro[FuncaoCadastro["Legendas"] = 27] = "Legendas";
    FuncaoCadastro[FuncaoCadastro["Visitantes"] = 28] = "Visitantes";
    FuncaoCadastro[FuncaoCadastro["Cobradoras"] = 29] = "Cobradoras";
    FuncaoCadastro[FuncaoCadastro["Atitudes"] = 30] = "Atitudes";
    FuncaoCadastro[FuncaoCadastro["Reconhecimentos"] = 31] = "Reconhecimentos";
    FuncaoCadastro[FuncaoCadastro["PeriodoBimestres"] = 32] = "PeriodoBimestres";
})(FuncaoCadastro = exports.FuncaoCadastro || (exports.FuncaoCadastro = {}));
var FuncaoSecretaria;
(function (FuncaoSecretaria) {
    FuncaoSecretaria[FuncaoSecretaria["Relatorios"] = 1] = "Relatorios";
    FuncaoSecretaria[FuncaoSecretaria["Frequencia"] = 2] = "Frequencia";
    FuncaoSecretaria[FuncaoSecretaria["RegistroFrequenciaManual"] = 3] = "RegistroFrequenciaManual";
    FuncaoSecretaria[FuncaoSecretaria["RegistroFrequenciaCartao"] = 4] = "RegistroFrequenciaCartao";
    FuncaoSecretaria[FuncaoSecretaria["CalcularFaltasBoletins"] = 5] = "CalcularFaltasBoletins";
    FuncaoSecretaria[FuncaoSecretaria["LerArquivoCatraca"] = 6] = "LerArquivoCatraca";
    FuncaoSecretaria[FuncaoSecretaria["RelatorioFrequenciaAlunos"] = 7] = "RelatorioFrequenciaAlunos";
    FuncaoSecretaria[FuncaoSecretaria["RelatoriosCatraca"] = 8] = "RelatoriosCatraca";
    FuncaoSecretaria[FuncaoSecretaria["CalcularAulasDadasPrevistasApartirPresencaManual"] = 9] = "CalcularAulasDadasPrevistasApartirPresencaManual";
    FuncaoSecretaria[FuncaoSecretaria["Notas"] = 10] = "Notas";
    FuncaoSecretaria[FuncaoSecretaria["ImprimirBoletinsConferencia"] = 11] = "ImprimirBoletinsConferencia";
    FuncaoSecretaria[FuncaoSecretaria["RelatorioAvaliacoesModuloOnline"] = 12] = "RelatorioAvaliacoesModuloOnline";
    FuncaoSecretaria[FuncaoSecretaria["RelatoriosMedias"] = 13] = "RelatoriosMedias";
    FuncaoSecretaria[FuncaoSecretaria["DigitacaoNotas"] = 14] = "DigitacaoNotas";
    FuncaoSecretaria[FuncaoSecretaria["DigitacaoBoletinsAluno"] = 15] = "DigitacaoBoletinsAluno";
    FuncaoSecretaria[FuncaoSecretaria["DigitacaoNovaNotas"] = 16] = "DigitacaoNovaNotas";
    FuncaoSecretaria[FuncaoSecretaria["RecalculoBoletinsPartirAvaliacoes"] = 17] = "RecalculoBoletinsPartirAvaliacoes";
    FuncaoSecretaria[FuncaoSecretaria["DigitacaoAvaliacoesDescritivas"] = 18] = "DigitacaoAvaliacoesDescritivas";
    FuncaoSecretaria[FuncaoSecretaria["Recuperacao"] = 19] = "Recuperacao";
    FuncaoSecretaria[FuncaoSecretaria["Reprovados"] = 20] = "Reprovados";
    FuncaoSecretaria[FuncaoSecretaria["Aprovados"] = 21] = "Aprovados";
    FuncaoSecretaria[FuncaoSecretaria["RelatorioIndividual"] = 22] = "RelatorioIndividual";
    FuncaoSecretaria[FuncaoSecretaria["RelAvaliacaoContinua"] = 23] = "RelAvaliacaoContinua";
    FuncaoSecretaria[FuncaoSecretaria["EncerramentoAnoLetivo"] = 24] = "EncerramentoAnoLetivo";
    FuncaoSecretaria[FuncaoSecretaria["CalculoMediaFinal"] = 25] = "CalculoMediaFinal";
    FuncaoSecretaria[FuncaoSecretaria["AberturaAnoLetivo"] = 26] = "AberturaAnoLetivo";
    FuncaoSecretaria[FuncaoSecretaria["ReMatriculaAutomatica"] = 27] = "ReMatriculaAutomatica";
    FuncaoSecretaria[FuncaoSecretaria["Utilitarios"] = 28] = "Utilitarios";
    FuncaoSecretaria[FuncaoSecretaria["RetornarAlunosSituacaoCurso"] = 29] = "RetornarAlunosSituacaoCurso";
    FuncaoSecretaria[FuncaoSecretaria["AcrescentarRemoverVirgulasNotasHistorico"] = 30] = "AcrescentarRemoverVirgulasNotasHistorico";
    FuncaoSecretaria[FuncaoSecretaria["MarcarDocumentosComoNaoEntregues"] = 31] = "MarcarDocumentosComoNaoEntregues";
    FuncaoSecretaria[FuncaoSecretaria["FecharReabrirAnoLetivo"] = 32] = "FecharReabrirAnoLetivo";
    FuncaoSecretaria[FuncaoSecretaria["GeracaoSenhasPaisAlunos"] = 33] = "GeracaoSenhasPaisAlunos";
    FuncaoSecretaria[FuncaoSecretaria["FichaIndividual"] = 34] = "FichaIndividual";
    FuncaoSecretaria[FuncaoSecretaria["HistoricoEscolar"] = 35] = "HistoricoEscolar";
    FuncaoSecretaria[FuncaoSecretaria["RelatorioFinal"] = 36] = "RelatorioFinal";
    FuncaoSecretaria[FuncaoSecretaria["RelatorioFinalMARFIN"] = 37] = "RelatorioFinalMARFIN";
    FuncaoSecretaria[FuncaoSecretaria["ExportacaoEducaCenso"] = 38] = "ExportacaoEducaCenso";
    FuncaoSecretaria[FuncaoSecretaria["FichaFamiliar"] = 39] = "FichaFamiliar";
    FuncaoSecretaria[FuncaoSecretaria["GerenciadorTurmas"] = 40] = "GerenciadorTurmas";
    FuncaoSecretaria[FuncaoSecretaria["AulasDadasTurma"] = 41] = "AulasDadasTurma";
    FuncaoSecretaria[FuncaoSecretaria["ConteudoMinistrado"] = 42] = "ConteudoMinistrado";
    FuncaoSecretaria[FuncaoSecretaria["ObservacoesSOE"] = 43] = "ObservacoesSOE";
    FuncaoSecretaria[FuncaoSecretaria["RelatorioOcorrencias"] = 44] = "RelatorioOcorrencias";
    FuncaoSecretaria[FuncaoSecretaria["RelatorioAtestadosMedicos"] = 45] = "RelatorioAtestadosMedicos";
    FuncaoSecretaria[FuncaoSecretaria["DiarioClasse"] = 46] = "DiarioClasse";
})(FuncaoSecretaria = exports.FuncaoSecretaria || (exports.FuncaoSecretaria = {}));
var FuncaoTesouraria;
(function (FuncaoTesouraria) {
    FuncaoTesouraria[FuncaoTesouraria["MovimentoCaixa"] = 1] = "MovimentoCaixa";
    FuncaoTesouraria[FuncaoTesouraria["Cheques"] = 2] = "Cheques";
    FuncaoTesouraria[FuncaoTesouraria["Cobranca"] = 3] = "Cobranca";
    FuncaoTesouraria[FuncaoTesouraria["ImprimirCarneCobranca"] = 4] = "ImprimirCarneCobranca";
    FuncaoTesouraria[FuncaoTesouraria["EnviarCobrancaBanco"] = 5] = "EnviarCobrancaBanco";
    FuncaoTesouraria[FuncaoTesouraria["GerarArquivoDebitoConta"] = 6] = "GerarArquivoDebitoConta";
    FuncaoTesouraria[FuncaoTesouraria["GerarArquivoCobradora"] = 7] = "GerarArquivoCobradora";
    FuncaoTesouraria[FuncaoTesouraria["GerarArquivoPagamentoFuncionarios"] = 8] = "GerarArquivoPagamentoFuncionarios";
    FuncaoTesouraria[FuncaoTesouraria["ImprimirCarnesSomenteValor"] = 9] = "ImprimirCarnesSomenteValor";
    FuncaoTesouraria[FuncaoTesouraria["ListagemAlunosDebitoConta"] = 10] = "ListagemAlunosDebitoConta";
    FuncaoTesouraria[FuncaoTesouraria["AlterarDiaVencimentoMensalidades"] = 11] = "AlterarDiaVencimentoMensalidades";
    FuncaoTesouraria[FuncaoTesouraria["GerarParcelasAdicionaisCobranca"] = 12] = "GerarParcelasAdicionaisCobranca";
    FuncaoTesouraria[FuncaoTesouraria["HistoricoImpressoesBloquetos"] = 13] = "HistoricoImpressoesBloquetos";
    FuncaoTesouraria[FuncaoTesouraria["BaixaMensalidades"] = 14] = "BaixaMensalidades";
    FuncaoTesouraria[FuncaoTesouraria["Manual"] = 15] = "Manual";
    FuncaoTesouraria[FuncaoTesouraria["Automatica"] = 16] = "Automatica";
    FuncaoTesouraria[FuncaoTesouraria["AutenticacaoMecanica"] = 17] = "AutenticacaoMecanica";
    FuncaoTesouraria[FuncaoTesouraria["PorCategoria"] = 18] = "PorCategoria";
    FuncaoTesouraria[FuncaoTesouraria["ConfiguracaoDescontos"] = 19] = "ConfiguracaoDescontos";
    FuncaoTesouraria[FuncaoTesouraria["RelatoriosContasPagar"] = 20] = "RelatoriosContasPagar";
    FuncaoTesouraria[FuncaoTesouraria["RelatoriosMensalidades"] = 21] = "RelatoriosMensalidades";
    FuncaoTesouraria[FuncaoTesouraria["RelatorioGratuidades"] = 22] = "RelatorioGratuidades";
    FuncaoTesouraria[FuncaoTesouraria["RelatoriosContabilidade"] = 23] = "RelatoriosContabilidade";
    FuncaoTesouraria[FuncaoTesouraria["RelatoriosCheques"] = 24] = "RelatoriosCheques";
    FuncaoTesouraria[FuncaoTesouraria["RelatorioTransporte"] = 25] = "RelatorioTransporte";
})(FuncaoTesouraria = exports.FuncaoTesouraria || (exports.FuncaoTesouraria = {}));
var FuncaoAdministracao;
(function (FuncaoAdministracao) {
    FuncaoAdministracao[FuncaoAdministracao["CaixaAdministracao"] = 1] = "CaixaAdministracao";
    FuncaoAdministracao[FuncaoAdministracao["FluxoCaixa"] = 2] = "FluxoCaixa";
    FuncaoAdministracao[FuncaoAdministracao["MovimentoBancario"] = 3] = "MovimentoBancario";
    FuncaoAdministracao[FuncaoAdministracao["AplicacoesFinanceiras"] = 4] = "AplicacoesFinanceiras";
    FuncaoAdministracao[FuncaoAdministracao["FecharReabrirContabilidadeMes"] = 5] = "FecharReabrirContabilidadeMes";
    FuncaoAdministracao[FuncaoAdministracao["RelatoriosAdministrativos"] = 6] = "RelatoriosAdministrativos";
    FuncaoAdministracao[FuncaoAdministracao["CadastroCentroCusto"] = 7] = "CadastroCentroCusto";
})(FuncaoAdministracao = exports.FuncaoAdministracao || (exports.FuncaoAdministracao = {}));
var FuncaoEstatastica;
(function (FuncaoEstatastica) {
    FuncaoEstatastica[FuncaoEstatastica["GraficosEstatisticos"] = 1] = "GraficosEstatisticos";
    FuncaoEstatastica[FuncaoEstatastica["NAlunosBairro"] = 2] = "NAlunosBairro";
    FuncaoEstatastica[FuncaoEstatastica["NAlunosTurma"] = 3] = "NAlunosTurma";
    FuncaoEstatastica[FuncaoEstatastica["Ranking"] = 4] = "Ranking";
    FuncaoEstatastica[FuncaoEstatastica["EstatasticaReligiao"] = 5] = "EstatasticaReligiao";
    FuncaoEstatastica[FuncaoEstatastica["EstatasticaCategoria"] = 6] = "EstatasticaCategoria";
    FuncaoEstatastica[FuncaoEstatastica["EstatasticaSituacao"] = 7] = "EstatasticaSituacao";
    FuncaoEstatastica[FuncaoEstatastica["EstatasticaRacaCor"] = 8] = "EstatasticaRacaCor";
})(FuncaoEstatastica = exports.FuncaoEstatastica || (exports.FuncaoEstatastica = {}));
var FuncaoUtilitarios;
(function (FuncaoUtilitarios) {
    FuncaoUtilitarios[FuncaoUtilitarios["AlterarSenhaUsuario"] = 1] = "AlterarSenhaUsuario";
    FuncaoUtilitarios[FuncaoUtilitarios["MonitorUsuarios"] = 2] = "MonitorUsuarios";
    FuncaoUtilitarios[FuncaoUtilitarios["EnviarMensagemRede"] = 3] = "EnviarMensagemRede";
    FuncaoUtilitarios[FuncaoUtilitarios["LogUsuarios"] = 4] = "LogUsuarios";
    FuncaoUtilitarios[FuncaoUtilitarios["DeltaUpdateAtualizarViaInternet"] = 5] = "DeltaUpdateAtualizarViaInternet";
    FuncaoUtilitarios[FuncaoUtilitarios["ChecarIntegridadeSistema"] = 6] = "ChecarIntegridadeSistema";
})(FuncaoUtilitarios = exports.FuncaoUtilitarios || (exports.FuncaoUtilitarios = {}));
var FuncaoInternet;
(function (FuncaoInternet) {
    FuncaoInternet[FuncaoInternet["RematriculaOnline"] = 1] = "RematriculaOnline";
    FuncaoInternet[FuncaoInternet["ExportadorInternet"] = 2] = "ExportadorInternet";
    FuncaoInternet[FuncaoInternet["MonitorSincronizacao"] = 3] = "MonitorSincronizacao";
    FuncaoInternet[FuncaoInternet["GerenciadorModulosWeb"] = 4] = "GerenciadorModulosWeb";
})(FuncaoInternet = exports.FuncaoInternet || (exports.FuncaoInternet = {}));
var FuncaoJanelas;
(function (FuncaoJanelas) {
    FuncaoJanelas[FuncaoJanelas["Emcascata"] = 1] = "Emcascata";
    FuncaoJanelas[FuncaoJanelas["LadoALadoHorizontalmente"] = 2] = "LadoALadoHorizontalmente";
    FuncaoJanelas[FuncaoJanelas["LadoALadoVerticalmente"] = 3] = "LadoALadoVerticalmente";
    FuncaoJanelas[FuncaoJanelas["OrganizarIcones"] = 4] = "OrganizarIcones";
})(FuncaoJanelas = exports.FuncaoJanelas || (exports.FuncaoJanelas = {}));
var FuncaoAjuda;
(function (FuncaoAjuda) {
    FuncaoAjuda[FuncaoAjuda["ConteudoAjuda"] = 1] = "ConteudoAjuda";
    FuncaoAjuda[FuncaoAjuda["IndiceAjuda"] = 2] = "IndiceAjuda";
    FuncaoAjuda[FuncaoAjuda["InformacoesSobreSistema"] = 3] = "InformacoesSobreSistema";
})(FuncaoAjuda = exports.FuncaoAjuda || (exports.FuncaoAjuda = {}));
